<template>
	<div class="singer">
		<SingerFront class="front" />
		<img src="@/assets/song.png" class="song" alt="" />
		<img src="@/assets/song.png" class="blur" alt="" />
		<slot/>
	</div>
</template>

<script>

import SingerFront from './illos/intro/SingerFront'

export default {
	name: 'Singer',
	components: {
		SingerFront
	}
}
</script>

<style lang="stylus" scoped>

.singer
	width 364.76px
	height 395.21px
	position absolute
	top 50%
	left 50%
	transform translate(-50%, -50%)
	.front
		position absolute
		bottom 0
		left 50%
		transform translateX(-50%)
		width 189.62px
		height 138.72px
		z-index 5

	.song
		position absolute
		bottom 5px
		left 56%
		transform translateX(-50%)
		width 311.63px
		height 326.71px
		z-index 4

	.blur
		filter blur(135px)
		position absolute
		bottom 0
		left 50%
		transform translateX(-50%)
		width 364.76px
		height 382px
		z-index 3

</style>
